import * as React from 'react';
import SpecialEmphasisApiService from '../../../api/SpecialEmphasisApiService';
import Routes from '../../../config/Routes';
import FeatureFlag from '../../../consts/FeatureFlag';
import SpecialEmphasisDataTableDTO from '../../../models/SpecialEmphasisDataTableDTO';
import TableRequestDTO from '../../../models/TableRequestDTO';
import BaseDataTableState from '../../../redux/bases/BaseDataTableState';
import BaseFormProps from '../../../redux/bases/BaseFormProps';
import BaseFormState from '../../../redux/bases/BaseFormState';
import AuthorizationUtil from '../../../utils/AuthorizationUtil';
import DateTimeUtil from '../../../utils/DateTimeUtil';
import FileDownload from '../../../utils/FileDownload';
import HistoryUtil from '../../../utils/HistoryUtil';
import DataTable, { DataTableColumnProps, FilterType } from '../core/DataTable';
import DataTableButtonUtil from '../core/DataTableButtonUtil';

interface SpecialEmphasisDataTableProps extends BaseFormProps {
}

interface SpecialEmphasisDataTableState extends BaseDataTableState<SpecialEmphasisDataTableDTO>, BaseFormState {
}

class SpecialEmphasisDataTable extends React.Component<SpecialEmphasisDataTableProps, SpecialEmphasisDataTableState> {
  private _dataTable: DataTable<SpecialEmphasisDataTableDTO> | undefined;

  constructor(props: SpecialEmphasisDataTableProps) {
    super(props);
    this.state = {
    };

  }

  private getColumnDefinitions = () => {
    return [
      {
        title: 'Code',
        dataIndex: SpecialEmphasisDataTableDTO.code,
        sorter: true,
        filterType: FilterType.Text,
        width: 125
      },
      {
        title: 'Name',
        dataIndex: SpecialEmphasisDataTableDTO.name,
        sorter: true,
        filterType: FilterType.Text
      }
    ] as DataTableColumnProps<any>[];
  };

  private openSpecialEmphasis = (record: SpecialEmphasisDataTableDTO) => {
    if (record.id) {
      HistoryUtil.push(Routes.generate(Routes.SPECIAL_EMPHASIS_DETAILS, { id: record.id }, {}));
    }
  }

  private addSpecialEmphasis = () => {
    HistoryUtil.push(Routes.generate(Routes.NEW_SPECIAL_EMPHASIS));
  }

  render() {
    const actionButtons = [];

    actionButtons.push(DataTableButtonUtil.Reset());
    actionButtons.push(
      DataTableButtonUtil.Export(
        (tableRequest: TableRequestDTO) => {
          this.setState({ exporting: true });
          return SpecialEmphasisApiService.getSpecialEmphasisDataTableExport(tableRequest).then(file => {
            this.setState({ exporting: false });
            FileDownload.downloadBase64StringAsFile(`Cip_Number_${DateTimeUtil.getDateStamp()}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', file ?? undefined);
          });
        },
        this.state.exporting
      )
    );

    if (AuthorizationUtil.isAuthorized([FeatureFlag.EDIT_SPECIAL_EMPHASIS])) {
      actionButtons.push(DataTableButtonUtil.Default('New Special Emphasis', () => this.addSpecialEmphasis()));
    }

    return (
      <>
        <DataTable
          ref={(element: any) => (this._dataTable = element)}
          onRowClick={this.openSpecialEmphasis}
          serverSide={true}
          tableProps={{
            rowKey: 'id',
            scroll: { x: 500 }
          }}
          globalSearch={true}
          buttonBar={actionButtons}
          columns={this.getColumnDefinitions()}
          fetchData={{
            fetch: (requestState: TableRequestDTO) => SpecialEmphasisApiService.getSpecialEmphasisTableData(requestState)
          }}
          stateSaving={{ enabled: true, tableUniqueKey: 'special_emphases_list' }} />
      </>
    );
  }
}

export default SpecialEmphasisDataTable;
